import * as React from 'react'
import styled from '../../../common/src/components/styled'
import { FetchAgentVirtualTourQuery, FetchProspectVirtualTourQuery } from '../../../common/src/types.gen'
import AgentVirtualTour from './AgentVirtualTour'
import ProspectVirtualTour from './ProspectVirtualTour'

const Center = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export interface VirtualTourProps {
  virtualTour?:
    | NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>
    | NonNullable<FetchProspectVirtualTourQuery['prospectVirtualTour']>
    | null
  error?: string
}

const VirtualTour = (props: VirtualTourProps) => {
  const { virtualTour, error } = props

  if (error != null) {
    return <Center>{error}</Center>
  }

  if (virtualTour == null) {
    return <Center>Bad Request</Center>
  }

  if (isAgentVirtualTour(virtualTour)) {
    return <AgentVirtualTour virtualTour={virtualTour} />
  }

  return <ProspectVirtualTour virtualTour={virtualTour} />
}

const isAgentVirtualTour = (
  virtualTour:
    | NonNullable<FetchProspectVirtualTourQuery['prospectVirtualTour']>
    | NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>
): virtualTour is NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']> =>
  virtualTour.__typename === 'AgentVirtualTour'

export default VirtualTour
